import React from 'react'
import './styles.scss'
import prettysize from '../../../utils'
import { Spin } from 'antd'

export default ({history, loading}) => {
  const { count, size, cost } = history
  return (
    <Spin spinning={loading}>
      <div className='last-month center-child indicator history'>
        <span>Transfers Last Month</span>
        <div className='content'>
          <span>{count + ' files'}</span>
          <span>{prettysize(size)}</span>
          <span>{'$' + cost}</span>
        </div>
      </div>
    </Spin>
  )
}
